import { Capacitor } from '@capacitor/core';
import { Geolocation } from '@capacitor/geolocation';

const DEFAULT_OPTIONS = {
  enableHighAccuracy: true,
  timeout: 10000,
  maximumAge: 0,
};

const toResult = (position, source) => ({
  ok: true,
  source,
  coords: {
    lat: position.coords.latitude,
    lon: position.coords.longitude,
    accuracy: position.coords.accuracy,
  },
});

export async function getCurrentCoordinates(options = {}) {
  const mergedOptions = { ...DEFAULT_OPTIONS, ...options };

  try {
    if (Capacitor.isNativePlatform()) {
      let permission = await Geolocation.checkPermissions();
      if (permission.location !== 'granted') {
        permission = await Geolocation.requestPermissions();
      }

      if (permission.location !== 'granted') {
        return { ok: false, error: 'Location permission denied' };
      }

      const position = await Geolocation.getCurrentPosition(mergedOptions);
      return toResult(position, 'native');
    }

    if (typeof navigator === 'undefined' || !navigator.geolocation) {
      return { ok: false, error: 'Geolocation is not supported in this environment' };
    }

    const position = await new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject, mergedOptions);
    });

    return toResult(position, 'web');
  } catch (err) {
    return {
      ok: false,
      error: err?.message || 'Unable to retrieve location',
    };
  }
}
